import { useState, useEffect } from 'react';
import { authController } from '../../controllers/authController';
import { Smartphone, Laptop, Globe, LogOut } from 'lucide-react';

const DeviceSessions = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [loggingOut, setLoggingOut] = useState(null); // kaunsa session logout ho raha hai

  const loadSessions = async () => {
    setLoading(true);
    const result = await authController.getSessions();
    if (result.success) {
      setSessions(result.data.sessions || []);
    }
    setLoading(false);
  };

  useEffect(() => { loadSessions(); }, []);

  const handleLogoutDevice = async (sessionId) => {
    setLoggingOut(sessionId);
    const result = await authController.logoutSession(sessionId);
    if (result.success) {
      setSessions(prev => prev.filter(s => s.sessionId !== sessionId));
    }
    setLoggingOut(null);
  };

  const getIcon = (deviceType) => {
    if (deviceType === 'android' || deviceType === 'ios') return <Smartphone size={20} />;
    if (deviceType === 'web') return <Globe size={20} />;
    return <Laptop size={20} />;
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '500px' },
    row: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '14px 16px', border: '1px solid #e5e7eb', borderRadius: '10px',
      backgroundColor: '#fff',
    },
    left: { display: 'flex', alignItems: 'center', gap: '12px' },
    iconWrap: {
      width: '40px', height: '40px', borderRadius: '50%',
      backgroundColor: '#eff6ff', color: '#2563eb',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    name: { fontSize: '14px', fontWeight: '600', color: '#1f2937' },
    meta: { fontSize: '12px', color: '#6b7280', marginTop: '2px' },
    currentBadge: {
      fontSize: '11px', fontWeight: '600', color: '#059669',
      backgroundColor: '#d1fae5', padding: '2px 8px', borderRadius: '999px', marginLeft: '8px',
    },
    logoutBtn: {
      display: 'flex', alignItems: 'center', gap: '6px',
      background: 'transparent', border: '1px solid #fca5a5', color: '#dc2626',
      padding: '8px 14px', borderRadius: '8px', fontSize: '13px', fontWeight: '500',
      cursor: 'pointer',
    },
    logoutBtnDisabled: { opacity: 0.5, cursor: 'not-allowed' },
    empty: { color: '#6b7280', fontSize: '14px', textAlign: 'center', padding: '20px' },
  };

  if (loading) return <div style={styles.empty}>Loading devices...</div>;

  return (
    <div style={styles.container}>
      {sessions.length === 0 && <div style={styles.empty}>Koi active device nahi mila</div>}
      {sessions.map(s => (
        <div key={s.sessionId} style={styles.row}>
          <div style={styles.left}>
            <div style={styles.iconWrap}>{getIcon(s.deviceType)}</div>
            <div>
              <div style={styles.name}>
                {s.deviceName}
                {s.isCurrent && <span style={styles.currentBadge}>This device</span>}
              </div>
              <div style={styles.meta}>
                {s.deviceType} • Logged in {new Date(s.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
              </div>
            </div>
          </div>
          {!s.isCurrent && (
            <button
              style={{ ...styles.logoutBtn, ...(loggingOut === s.sessionId ? styles.logoutBtnDisabled : {}) }}
              onClick={() => handleLogoutDevice(s.sessionId)}
              disabled={loggingOut === s.sessionId}
            >
              <LogOut size={14} />
              {loggingOut === s.sessionId ? 'Logging out...' : 'Logout'}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default DeviceSessions;